import { render, staticRenderFns } from "./OrderDevicesTab.vue?vue&type=template&id=4252ebe0&scoped=true&"
import script from "./OrderDevicesTab.vue?vue&type=script&lang=js&"
export * from "./OrderDevicesTab.vue?vue&type=script&lang=js&"
import style0 from "./OrderDevicesTab.vue?vue&type=style&index=0&id=4252ebe0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4252ebe0",
  null
  
)

export default component.exports